<template>
  <div class="card shadow-sm">
    <div class="d-flex w-100 p-3 justify-content-between mt-1 border-bottom position-relative card-title-ido">
      <h5 class="fw-bold text-primary">设备分布</h5>
      <a href="#" class="card-link text-primary point-curser" @click="more()">更多</a>
    </div>
    <div class="list-box mt-2 d-flex align-items-center justify-content-center" v-if="loading || (!loading && list.length<=0)">
      <!-- loading-->
      <div v-if="loading"  class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <!--              暂无数据-->
      <div v-if="!loading && list.length<=0" class="text-secondary fw-bold" role="status">
        <span >暂无数据</span>
      </div>
    </div>
    <div class="list-box mt-2" v-else>
      <div class="d-flex w-100 py-2 px-3 justify-content-between flex-shrink-0" v-for="(item,index) of list" :key="index" @click="goDetail(item)">
        <div class="me-4 point-curser list-des fw-medium">
          {{item.Name}}</div>
        <div class="list-time text-primary">{{item.DeviceCount || 0}}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref,computed,defineProps} from "vue";
import router from "@/router";
import {useStore} from 'vuex'
const store = useStore()
// const list = ref([])
const list = computed(()=> store.state.homeModel.device_dist)//设备分布
// const loading = ref(true)
defineProps({
  loading:{
    default:true
  }
})
onMounted(()=>{

})
const more = () => {
  router.push({path:'/equipmentsharing'})
}

const goDetail = (item)=>{
  sessionStorage.setItem('SZHXTPTCLASSICE', item.ID);
  router.push({path:'/equipmentsharing'})

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/css/FirstPageListStyle.scss";
</style>
